<template lang="jade">
	include ../../node_modules/tangram-ui/src/elements/tge-svg-icons/tge-svg-icons.jade


	.map-item_container
		//- , @click.self="resetZoom($event)"
		svg.map-item_svg(:width="displayWidth", :height="displayHeight", :class="{  filtered: this.filters.party, responsive: responsive }")
			transition(appear, name="fade")
				g.features(v-if="topojson", :key="year")
					path(
						v-for="(feature, i) in features",
						:district-id="feature.properties.ID",
						:district-name="feature.properties.NAME",
						:d="feature.path",
						:style="{ fill: feature.fillColor }",

						@mouseover="showTooltip(feature.results, $event)",
						@mousemove="moveTooltip",
						@mouseout="hideTooltip")
				//-@click="onClicked(feature, $event)",

		.tooltip(:style="tooltipStyles")
			template(v-if="tooltipData")
				.tooltip_close(@click="resetZoom && hideTooltip")
					+tge-svg-icons({ icon: "close" })
				DistrictDataTable(:district="tooltipData")



</template>
<script>
	import DistrictDataTable from './DistrictDataTable.vue'
	import tooltipMixin from '../mixins/tooltip';

	import topojsonFeature from 'topojson-client/src/feature';

	import { interpolate } from 'd3-interpolate';
	import { geoMercator, geoPath } from 'd3-geo';
	import { select /*, event */ } from 'd3-selection';
	import { zoom, zoomIdentity } from 'd3-zoom';


	const d3 = {
		geoMercator,
		geoPath,
		interpolate,
		select,
		zoom,
		zoomIdentity
	};

	export default {
		name: "map-item-svg",
		mixins: [ tooltipMixin ],
		props: {
			geodata: {
				type: Object,
				required: true
			},
			results: {

			},
			year:{},
			width: {
				type: Number,
				default: 200
			},
			height: {
				type: Number,
				default: 300
			},
			initialScale: {
				type: Number,
				//default: 1525.9150802707925
			},
			centerPoint: {
				type: Array,
				default: () => [145.76898849997664,-19.44343762302302]
			},
			zoomScale: {
				type: Array,
				default: () => [1, Infinity]
			},
			filters: {
				type: Object
			},
			responsive: {
				type: Boolean,
				default: false
			}
		},
		components: { DistrictDataTable },
		data() {
			return {
				topojson: null,
				selectedID: null,
				// responsive: false,
				tooltipOffset: { x: 5, y: 5 },
				tooltipData: null,
				colors: {
					LNP: '#3D85C6',
					ALP: '#c00',
					GRN: '#6AA84F',
					IND: '#999',
					OTH: '#F1C232',
					KAP: 'maroon',
					ZZZ: '#999',
					PUP: '#F1C232',
					ONP: 'purple',
					FFP: '#f69a51'
				},
				activePath: null,
				displayWidth: 0,
				displayHeight: 0
			}
		},
		mounted: function(){
			// console.log('map-item mounted', this.$el);
			// this.initZoom();
			this.updateBoundaries();

			window.addEventListener('resize', this.resize);
			window.addEventListener('orientationchange', this.resize);
		},
		watch: {
			year(val) {
				console.log(`SVG component: Year changed to ${val}. Update boundaries`);
				this.topojson = null;
				this.updateBoundaries();
			}
		},
		computed: {

			aspectRatio() {
				// console.log(this.height / this.width)
				return this.height / this.width;
			},
			dimensions: {
				get: function () {
					return {
						width: this.displayWidth,
						height: this.displayHeight
					};
				},
				// setter
				set: function ({ width /* , height*/ }) {
					// console.log(width, height, this.aspectRatio, width * this.aspectRatio)
					this.displayWidth = width;
					this.displayHeight = width * this.aspectRatio;
					// this.height = this.featuresGroup.clientHeight;
					// console.log(this.height, width * this.aspectRatio)
				}
			},
			boundaries() {
				// Object container the Electoral Boundary geopaths
				return this.geodata.objects.electoral_boundaries;
			},
			svg() {
				return d3.select(this.$el).select('svg');
			},
			featuresGroup() {
				// Group for the map features
				return this.svg.select("g.features");
			}/*,
			topojson() {
				return;
				return topojsonFeature(this.geodata, this.boundaries);
			}*/,
			features() {
				return this.topojson.features.map( (feature) => {
					const featureData =  {
						...feature,
						path: this.path(feature)
					}
					// console.log('features', this.year, this.$store.getters.getDistrictById(feature.properties.ID, this.year))
						Object.assign(featureData, {
							results: this.$store.getters.getDistrictById(feature.properties.ID, this.year),
							fillColor: this.getFillColour(feature.properties.ID),
						});

					return featureData;
				});
			},
			projection() {
				// console.log(this.dimensions)
				const projection = d3.geoMercator()
				// const projection = geoMercator()
					.center(this.centerPoint) //projection center
					.translate([this.dimensions.width / 2, this.dimensions.height / 2]); //translate to center the map in view


				if (this.initialScale) {
					projection.scale(this.initialScale);
				} else {
					projection.fitSize([this.dimensions.width, this.dimensions.height], this.topojson)
				}

				return projection;
			},
			path() {
				return d3.geoPath().projection(this.projection);
			},
			zoom() {
				// Create zoom/pan listener
				// Change [1,Infinity] via props to adjust the min/max zoom scale
				return d3.zoom()
					.scaleExtent(this.zoomScale)
					.translateExtent([[-0, -0], [this.dimensions.width + 0, this.dimensions.height + 0]])
					.on("zoom", this.onZoom);
			},
			tooltip() {
				return this.$el.querySelector('.tooltip');
			},
			districtData: {
				// getter
				get: function () {
					return this.tooltipData;
				},
				// setter
				set: function (d) {
					this.tooltipData = d;
				}
			},
			fillColorArray() {
				return this.features.map( (feature) => {
					return this.getFillColour(feature.properties.ID);
				})
			}
		},
		methods: {
			getFillColour(id) {
				const districtData = this.$store.getters.getDistrictById(id, this.year);

				let color = '#eee';
				if (!districtData) return color;

				// const declaredParty = districtData['declaredPartyCode'];

				if (this.filters && this.filters.party) {
					color = this.colors[this.filters.party] || '#eee';

					const
						partyData = districtData.candidates.find( (candidate) => candidate['party'] === this.filters.party ),
						partyPercent = partyData ? parseInt(partyData.primaryVotes.percentage, 10) / 100 : 0.01;

					if (partyPercent) {
						const minColor = '#fff';
						color = d3.interpolate(minColor, color)(partyPercent);
					}

				} else {
					const
						sortedData = districtData.candidates.slice().sort( (a, b) => {
							return b.primaryVotes.count - a.primaryVotes.count;
						} ),
						leadingParty = sortedData[0].primaryVotes.count > 0 ? sortedData[0].party : null;

					color = this.colors[leadingParty] || '#ccc';
					//color = this.colors[declaredParty] || '#ccc';
				}
				// console.log(declaredParty, color)
				return color;

			},

			resize() {
				this.dimensions = {
					width: this.$el.clientWidth,
					height: this.$el.clientHeight
				};
			},
			onClicked(d, e) {
				// console.log('click',d, e, this);
				if (this.activePath === e.target) {
					this.resetZoom();
				} else {
					this.zoomToDistrict(d, e);
				}
			},
			updateBoundaries() {
				this.$store.commit('loading', true);
				setTimeout(() => {
					this.$store.commit('loading', true);
					this.topojson = topojsonFeature(this.geodata, this.boundaries);

					setTimeout(() => this.$store.commit('loading', false), 300);
				}, 300)
				this.resize();
			},
			resetZoom() {
				
			}/*,

			initZoom() {
				//this.svg.call(this.zoom); //svg.call(zoom);
			},
			onZoom() {
				d3.event = event;
				this.featuresGroup.attr("transform", d3.event.transform).selectAll("path:not(.active)").style("stroke-width", 1 / d3.event.transform.k + "px" );
				this.featuresGroup.attr("transform", d3.event.transform).select("path.active").style("stroke-width", 2 / d3.event.transform.k + "px" );
			},
			zoomToDistrict(d, e) {

				this.selectedID = parseInt(d.properties.ID, 10);

				if (this.activePath) this.activePath.classList.remove('active');
				this.activePath = e.target;
				this.activePath.classList.add('active');

				const
					bounds = this.path.bounds(d),
					dx = bounds[1][0] - bounds[0][0],
					dy = bounds[1][1] - bounds[0][1],
					x = (bounds[0][0] + bounds[1][0]) / 2,
					y = (bounds[0][1] + bounds[1][1]) / 2,
					scale = Math.max(1, Math.min(8, 0.9 / Math.max(dx / this.dimensions.width, dy / this.dimensions.height))),
					translate = [this.dimensions.width / 2 - scale * x, this.dimensions.height / 2 - scale * y];

				this.svg.transition()
					.duration(750)
					.call( this.zoom.transform, d3.zoomIdentity.translate(translate[0],translate[1]).scale(scale) ); // updated for d3 v4

				// console.log(d.properties, this.districtData, e);
				this.cursorPos = { x: e.pageX, y: e.pageY }
			},
			resetZoom() {
				console.log('reset');
				if (this.activePath) {
					this.activePath.classList.remove('active');
					this.activePath = null;
				}

				this.selectedID = null;

				this.svg.transition()
					.duration(750)
					.call( this.zoom.transform, d3.zoomIdentity );
			}*/
			/**/
		}
	}
</script>
<style lang="scss">
	@import "node_modules/tangram-ui/src/elements/tge-svg-icons/tge-svg-icons";

	.map-inset {
		display:inline-block;
		text-align: center;

		svg.map-item_svg {
			overflow: hidden;
			background-color: #eee;
			border-radius: 100%;

			&:not(.filtered) path {
				stroke-width: 1.0px;
				stroke: #fff;
			}

			&.filtered {
				border: 1px solid rgba(0,0,0,0.5)
			}
		}
	}

	.map-item_svg {

		&.responsive {
			width: 100%;
		}

		path {
			stroke-width: 1px;
			stroke: rgba(255,255,255,0.8);
			fill: #ddd;
			cursor: pointer;
			transition: opacity 0.3s;
		}

		&.filtered path { stroke: rgba(0,0,0,0.5); }

		path:not(.active):hover {
			opacity: 0.8;
		}
		path {
			// cursor: zoom-in;

			&.active {
				// cursor: zoom-out;
			}
		}


		&.hasSelection {
			path:not(.active) { opacity: 0.2; }
		}
	}






</style>



// WEBPACK FOOTER //
// MapSVG.vue?428fe41c